module.exports = "/assets/data/abc2afa76183ccdbfcb8516635c8b572-LE18.data.json";